import * as UsersConnection from 'connections/users';

export const addEmailToMatrix = async (matrixId, email, userId) => {
  return await UsersConnection.addEmailToMatrix(matrixId, email, userId);
};

export const removeEmailFromMatrix = async (
  matrixId,
  userId,
  userIdToRemove
) => {
  return await UsersConnection.removeEmailFromMatrix(
    matrixId,
    userId,
    userIdToRemove
  );
};

export const get = async (id, user, userData) => {
  return await UsersConnection.get(id, user, userData);
};

export const save = async (
  id,
  userData,
  requestingUser,
  requestingUserData
) => {
  return await UsersConnection.save(
    id,
    userData,
    requestingUser,
    requestingUserData
  );
};
